import Typography from "@bmi-digital/components/typography";
import { microCopy } from "@bmi-digital/dxb-microcopies";
import React from "react";
import RichText from "../../../components/RichText";
import { useSiteContext } from "../../../components/Site";
import { TitleWithContentData } from "../../../components/TitleWithContent";
import { Title } from "./training-catalogue-styles";

type Props = {
  searchTips?: TitleWithContentData | null;
};

const TrainingNoResults = ({ searchTips }: Props) => {
  const { getMicroCopy } = useSiteContext();

  const searchTitle = getMicroCopy(microCopy.TRAINING_LISTING_NO_SEARCH_TITLE);
  const searchDescription = getMicroCopy(
    microCopy.TRAINING_LISTING_NO_SEARCH_DESCRIPTION
  );

  return (
    <>
      <div>
        <Title variant="h3" hasUnderline data-testid="nosearch-catalogue-title">
          {searchTitle}
        </Title>

        <Typography data-testid="nosearch-catalogue-description">
          {searchDescription}
        </Typography>
      </div>
      {searchTips && (
        <div style={{ marginTop: "20px" }}>
          {searchTips.title && (
            <Typography variant="h4" data-testid="nosearch-training-title">
              {searchTips.title}
            </Typography>
          )}
          <RichText document={searchTips.content} />
        </div>
      )}
    </>
  );
};

export default TrainingNoResults;
